import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MarketingChannel } from 'constants/enums/marketingChannels'

interface ChannelConfig {
	channel: MarketingChannel
	labelKey: string
	descriptionKey?: string
	defaultChecked: boolean
}

const MARKETING_CHANNELS: ChannelConfig[] = [
	{
		channel: MarketingChannel.AppNotifications,
		labelKey: 'MarketingChannelAppNotifications',
		defaultChecked: true,
	},
	{
		channel: MarketingChannel.Email,
		labelKey: 'MarketingChannelEmail',
		defaultChecked: true,
	},
	{
		channel: MarketingChannel.SMS,
		labelKey: 'MarketingChannelSMS',
		defaultChecked: false,
	},
]

const MARKETING_OFFERS: ChannelConfig[] = [
	{
		channel: MarketingChannel.PartnerOffers,
		labelKey: 'MarketingChannelPartnerOffers',
		descriptionKey: 'MarketingChannelPartnerOffersDescription',
		defaultChecked: false,
	},
]

interface MarketingPreferencesProps {
	onSelectionChange?: (selected: MarketingChannel[]) => void
}

export const MarketingPreferences = ({
	onSelectionChange,
}: MarketingPreferencesProps) => {
	const { t } = useTranslation()

	const [selected, setSelected] = useState<Set<MarketingChannel>>(
		new Set(
			MARKETING_CHANNELS.filter((c) => c.defaultChecked).map(
				(c) => c.channel,
			),
		),
	)

	const toggle = (channel: MarketingChannel) => {
		setSelected((prev) => {
			const next = new Set(prev)
			if (next.has(channel)) {
				next.delete(channel)
			} else {
				next.add(channel)
			}
			onSelectionChange?.(Array.from(next))
			return next
		})
	}

	return (
		<div className="avarda-page-segment-white marketing-preferences">
			<h4>{t('MarketingPreferencesHeader')}</h4>
			<p className="marketing-preferences-description">
				{t('MarketingPreferencesDescription')}
			</p>
			<div className="marketing-channels-grid">
				<div>
					{t('Channels')}
					{MARKETING_CHANNELS.map(
						({ channel, labelKey, descriptionKey }) => {
							const isChecked = selected.has(channel)
							return (
								<label
									key={channel}
									className="marketing-channel-item">
									<input
										type="checkbox"
										className="marketing-channel-checkbox"
										checked={isChecked}
										onChange={() => toggle(channel)}
									/>
									<div className="marketing-channel-text">
										<span className="marketing-channel-label">
											{t(labelKey)}
										</span>
										<span className="marketing-channel-description">
											{descriptionKey
												? t(descriptionKey)
												: ' '}
										</span>
									</div>
								</label>
							)
						},
					)}
				</div>

				<div>
					{t('Offers')}
					{MARKETING_OFFERS.map(
						({ channel, labelKey, descriptionKey }) => {
							const isChecked = selected.has(channel)
							return (
								<label
									key={channel}
									className="marketing-channel-item">
									<input
										type="checkbox"
										className="marketing-channel-checkbox"
										checked={isChecked}
										onChange={() => toggle(channel)}
									/>
									<div className="marketing-channel-text">
										<span className="marketing-channel-label">
											{t(labelKey)}
										</span>
										<span className="marketing-channel-description">
											{descriptionKey
												? t(descriptionKey)
												: ' '}
										</span>
									</div>
								</label>
							)
						},
					)}
				</div>
			</div>
		</div>
	)
}
